GZ.defaults = {

  _menusOpen: false,

  init: function() {
    this.mainNavigation();
  },

  mainNavigation: function() {
    var self = this;
    var isAnimating = false;
    $(".mainnav .has-children").on("click", function(event) {
      event.stopPropagation();
      if (isAnimating) return false;
      var openingPopup = $(this).find(".opening-popup");
      if (openingPopup.length > 0 && !openingPopup.hasClass("visible")) {
        isAnimating = true;
        self._menusOpen = true;
        $(this).find("i").addClass("visible");
        window.setTimeout(function() {
          openingPopup.addClass("visible");
        },50);
        openingPopup.stop().fadeIn(150, function(){
          isAnimating = false;
        });
      } else {
        isAnimating = true;
        $(this).find("i").removeClass("visible");
        openingPopup.removeClass("visible");
        openingPopup.stop().fadeOut(150, function(){
          isAnimating = false;
          self._menusOpen = false;
        });
      }
    });

    $(".mainnav .more-info").on("click", function(event) {
      event.stopPropagation();
      $("html, body").animate({
        scrollTop: $(".content_footer .col_right").offset().top
      },800);
    });

    $('html').on('click',function() {
      if (self._menusOpen) {
        var openingPopup = $(".mainnav .has-children").find(".opening-popup");
        if(openingPopup.length > 0) {
          isAnimating = true;
          openingPopup.parent().find("i").removeClass("visible");
          openingPopup.removeClass("visible");
          openingPopup.stop().fadeOut(150, function(){
            isAnimating = false;
            self._menusOpen = false;
          });
        }
      }
    });
  }
};
